// Libs
import _size from 'lodash/size'
import _head from 'lodash/head'
import _cloneDeep from 'lodash/cloneDeep'
import _reduce from 'lodash/reduce'
import _findIndex from 'lodash/findIndex'

// Constants
import {
  SOIL_TEST_FILTER_OPTIONS as filterOptions,
  PROP_MIN_DEPTH,
  PROP_MAX_DEPTH,
  PROP_DEPTH_UNIT,
  LABEL_MIN_DEPTH,
  LABEL_MAX_DEPTH,
  BRANCH,
} from 'fc-model-soil-test-results/src/constants'

export default function (samplingPoints) {
  const noOptions = [{ label: 'No results available', value: null }]
  const has = Object.prototype.hasOwnProperty
  if (samplingPoints && _size(samplingPoints)) {
    const sample = _head(samplingPoints)
    if (has.call(sample, BRANCH) && _size(sample[BRANCH])) {
      const picked = _cloneDeep(_head(sample[BRANCH]))
      Object.keys(picked).forEach((key) => (picked[key] === null) && delete picked[key])
      const options = _reduce(filterOptions, function (result, value) {
        const nutrientKey = value.value
        const hasValue = has.call(picked, nutrientKey)
        if (!result || hasValue) {
          result.push(value)
        }
        return result
      }, [])
      // Check and add min/max depth unit
      const hasDepthUnit = has.call(picked, PROP_DEPTH_UNIT)
      const maxDepthKey = _findIndex(options, {value: PROP_MAX_DEPTH})
      const minDepthKey = _findIndex(options, {value: PROP_MIN_DEPTH})

      if (hasDepthUnit && (minDepthKey > -1 || maxDepthKey > -1)) {
        if (maxDepthKey > -1) {
          options[maxDepthKey].label = `${LABEL_MAX_DEPTH} (${picked[PROP_DEPTH_UNIT]})`
        }
        if (minDepthKey > -1) {
          options[minDepthKey].label = `${LABEL_MIN_DEPTH} (${picked[PROP_DEPTH_UNIT]})`
        }
      }
      return options
    } else return noOptions
  } else return noOptions
}
